import * as React from "react";

import { style, MyIconProps } from "./MyIcons";

export const Heart = (props: MyIconProps): React.ReactElement => {
  return (
    <svg
      ref={props.elementRef}
      className={props.className}
      style={{ ...style(props), ...props.style }}
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    >
      <path d="M2 12H3.54" />
      <path d="M20.54 12H22" />
      <path d="M4.92999 19.07L6.01999 17.98" />
      <path d="M18.04 5.95999L19.07 4.92999" />
      <path d="M12 22V20.46" />
      <path d="M12 3.46V2" />
      <path d="M19.07 19.07L17.98 17.98" />
      <path d="M5.95999 5.95999L4.92999 4.92999" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.351 9.661L12 10.034L11.649 9.661C10.879 8.843 9.60201 8.776 8.75001 9.508V9.508C7.88001 10.256 7.77601 11.553 8.49201 12.451C9.51601 13.735 10.69 15.002 12 16C13.343 14.978 14.542 13.672 15.584 12.355C16.26 11.5 16.122 10.259 15.295 9.548L15.257 9.515C14.399 8.776 13.121 8.843 12.351 9.661V9.661Z"
      />
    </svg>
  );
};
